import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCategory } from '../../context/CategoryContext';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { FaSpinner } from 'react-icons/fa'; // Spinner ícone
import './ProductCarousel.css';

import card1 from "../../img/eletromestico.png";
import card2 from "../../img/ENERGIA.png";
import card3 from "../../img/imagem e som.png";
import card4 from "../../img/IMPRESSORAS.png";
import card5 from "../../img/INFORMaTICA.png";
import card6 from "../../img/redes e internet.png";
import card7 from "../../img/SEGURANcA ELECTRoNICA.png";
import card8 from "../../img/SMARTPHONES.png";
import card9 from "../../img/Software.png";
import card10 from "../../img/eletromestico.png";

const categories = [
  { id: 1, name: 'Electrodomésticos', image: card1, link: '/category/eletrodomesticos' },
  { id: 2, name: 'Energia', image: card2, link: '/category/energia' },
  { id: 3, name: 'Imagem e Som', image: card3, link: '/category/imagem-e-som' },
  { id: 4, name: 'Impressão', image: card4, link: '/category/impressao' },
  { id: 5, name: 'Informática', image: card5, link: '/category/informatica' },
  { id: 6, name: 'Redes, Internet e Telecomunicações', image: card6, link: '/category/redes-internet' },
  { id: 7, name: 'Segurança Electrónica', image: card7, link: '/category/seguranca-eletronica' },
  { id: 8, name: 'Smartphones, Tablets e Telemóveis', image: card8, link: '/category/smartphones' },
  { id: 9, name: 'Software', image: card9, link: '/category/software' },
  { id: 10, name: 'Material de Escritório e Escolar', image: card10, link: '/category/material-de-escritorio' },
];

const CategoryCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(5);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { setCategory } = useCategory();

  const updateVisibleCards = () => {
    const width = window.innerWidth;
    if (width < 576) {
      setVisibleCards(1);
    } else if (width < 768) {
      setVisibleCards(2);
    } else if (width < 992) {
      setVisibleCards(3);
    } else if (width < 1200) {
      setVisibleCards(4);
    } else {
      setVisibleCards(5);
    }
  };

  useEffect(() => {
    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Simula carregamento
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % categories.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % categories.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + categories.length) % categories.length);
  };

  const renderVisibleCategories = () => {
    const visibleCategories = [];
    for (let i = 0; i < visibleCards; i++) {
      const index = (currentIndex + i) % categories.length;
      visibleCategories.push(
        <div
          className="card-banner"
          key={categories[index].id}
          onClick={() => {
            setCategory(categories[index].name);
            navigate(categories[index].link);
          }}
        >
          <img
            src={categories[index].image}
            alt={categories[index].name}
            className="category-image"
          />
          <p>{categories[index].name}</p>
        </div>
      );
    }
    return visibleCategories;
  };

  return (
    <div className="carousel-container-banner">
      <h3 style={{ textAlign: "center" }}>Nossas categorias</h3>

      {isLoading ? (
        <div className="loading-container">
          <FaSpinner className="spinner" size={30} />
    
        </div>
      ) : (
        <>
          <div className="carousel-banner">
            {renderVisibleCategories()}
          </div>
          <div className="carousel-controls">
            <button className="carousel-button" onClick={handlePrev}>
              <FiChevronLeft />
            </button>
            <button className="carousel-button" onClick={handleNext}>
              <FiChevronRight />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CategoryCarousel;
